module.exports = __webpack_public_path__ + "static/pool-fe0feee73a76a536c9040532e884ed27.webm";